import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
`;

export const ContainerWidth = styled.div`
  background-color: ${(props) => props?.backgroundColor ?? "transparent"};
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  @media only screen and (min-width: 769px) {
    width: 1016px;
    z-index: 2;
  }
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${(props) => props.backgroundColor || "#fff"};
  margin-bottom: ${(props) => props.marginBottom || "32px"};
  padding-left: ${(props) => props.paddingLeft || "24px"};
  padding-right: ${(props) => props.paddingRight || "24px"};

  @media only screen and (min-width: 769px) {
    margin-bottom: 64px;
    padding-left: 0px;
    padding-right: ${(props) => props.paddingRight || "0px"};
  }
`;

export const GallerySectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #0c1219;
`;

export const GalleryCardContainer = styled.div`
  background-image: linear-gradient(
      179.95deg,
      rgba(0, 0, 0, 0) 42.72%,
      rgba(0, 0, 0, 0.5) 71.31%,
      rgba(0, 0, 0, 0.9) 99.95%
    ),
    ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: ${(props) => props?.width ?? "276px"};
  height: 430px;
  display: flex;
  border-radius: 16px;
  align-items: end;
  cursor: pointer;
  transition: background-size 0.7s ease-in-out; /* Smoother transition */

  &:hover {
    background-size: 120%; /* Increase size for zoom effect */
  }

  @media only screen and (max-width: 376px) {
    height: 387px;
  }

  @media only screen and (min-width: 769px) {
    width: 280px;
    height: 457px;
  }
`;

export const InnerGalleryCard = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  justify-content: end;
  padding: 16px;
  /* background-color: rgba(0, 0, 0, 0.4); */
`;

export const GalleryTitle = styled.p`
  margin: 0;
  color: #fff;
  font-weight: bold;
  font-size: 23px;
  line-height: 29px;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
    line-height: 37px;
  }
`;

export const GallerySubTitle = styled.p`
  margin: 0;
  color: #fff;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  gap: 4px;
`;

export const ButtonGallery = styled.button`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border-radius: 40px;
  border: 1px solid #ffffff;
  background-color: transparent;

  &:hover {
    background-color: #00bcf1;
    border: none;
  }
`;

export const TopRightSwosh = styled.img`
  position: absolute;
  top: 0;
  right: 0;
`;

export const BottomLeftSwosh = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
`;

export const SliderContainer = styled.div`
  margin-top: 20px;
  position: relative;
  @media only screen and (min-width: 768px) {
    width: calc(100% + 96px);
    height: 20px;
    display: flex;
    justify-content: center;
  }
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0;
  border-radius: 16px;
  position: relative;
  left: -12px;

  svg {
    object-fit: contain;
    border-radius: 16px;
    position: relative;
  }

  @media screen and (max-width: 768px) {
    svg {
      width: 60%;
      height: 60%;
    }
  }

  @media screen and (max-height: 700px) {
    margin: 12px 0;
  }
`;
